// GENERATED by scripts/fetch-store-badges.py — do not edit by hand.
//
// Intrinsic sizes of the official store badges in public/, so every <img>
// can carry an explicit width and height. The badges differ in width per
// language, so a single shared ratio would stretch most of them and shift
// the layout as each one loads.
//
// Apple values are the SVG's own units (height 40). Play values are the
// cropped PNG's ratio expressed at height 44. Scale by height as needed.
export const BADGE_SIZE = {
  apple: {
    da: [119.66, 40.0],
    de: [119.66, 40.0],
    en: [119.66, 40.0],
    'es-es': [119.66, 40.0],
    'es-mx': [119.66, 40.0],
    fr: [126.51, 40.0],
    it: [119.66, 40.0],
    ja: [108.85, 40.0],
    ko: [129.7, 40.0],
    nl: [119.66, 40.0],
    'pt-br': [119.66, 40.0],
    'pt-pt': [119.66, 40.0],
    'zh-cn': [108.85, 40.0],
    'zh-tw': [108.85, 40.0],
  },
  play: {
    da: [148.04, 44.0],
    de: [148.04, 44.0],
    en: [147.71, 44.0],
    es: [148.04, 44.0],
    'es-419': [148.04, 44.0],
    fr: [148.04, 44.0],
    it: [148.04, 44.0],
    ja: [148.04, 44.0],
    ko: [148.04, 44.0],
    nl: [148.04, 44.0],
    no: [148.04, 44.0],
    'pt-br': [148.04, 44.0],
    'zh-cn': [148.04, 44.0],
    'zh-tw': [148.04, 44.0],
  },
}
